import { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { useParams } from 'react-router-dom';
import { Box, useToast } from '@chakra-ui/react';

import WithTheme from 'src/hocs/withTheme';
import { useQuery } from 'src/hooks/useQuery';
import { ProductsService } from 'src/services/Products';

import { BackButton, CenteredProgress } from 'src/chakra-components';

import { Info } from './components/Info';
import { Form } from './components/Form';
import { VariantsTable } from './components/VariantsTable';
import { TOAST_MESSAGE_DESCRIPTOR, mapProductDTOToProduct } from './utils';

export const Product = () => {
  const { id: productId } = useParams();

  const intl = useIntl();
  const toast = useToast();

  const {
    data: product,
    isLoading: productIsLoading,
    error: productError,
  } = useQuery(() => ProductsService.getProductById({ id: productId }), {
    dataMapper: mapProductDTOToProduct,
  });

  useEffect(() => {
    if (productError) {
      toast(TOAST_MESSAGE_DESCRIPTOR.FETCH_PRODUCT_FAILED(intl));
    }
  }, [productError]);

  if (productIsLoading || !product) {
    return <CenteredProgress />;
  }

  const onSubmit = updatedProduct => {
    console.log(updatedProduct);
  };

  const shouldShowVariantsTable = product.variants.length > 1;

  return (
    <Box m={6} maxW={{ base: '100vw', md: 'xl', lg: '2xl' }}>
      <BackButton to="/product" />
      <Info product={product} />
      <Form product={product} onSubmit={onSubmit} />
      {shouldShowVariantsTable && <VariantsTable product={product} />}
    </Box>
  );
};

export default WithTheme(Product);
